import { useTracker } from 'infrastructure/hooks/shared/useTracker';
import { getTrackerTitle } from 'infrastructure/hooks/shared/useTracker/getTrackerTitle';
import React, { useEffect, type FC } from 'react';

interface TimerProps {
  useTrackerRef: React.MutableRefObject<
    ReturnType<typeof useTracker> | undefined
  >;
}

const Timer: FC<TimerProps> = ({ useTrackerRef }) => {
  const tracker = useTracker();

  useEffect(() => {
    useTrackerRef.current = tracker;
  }, [tracker]);

  const rightTitle = getTrackerTitle({
    isMinimized: true,
    trackerTimer: tracker.time,
  });

  return <div>{rightTitle}</div>;
};
export default Timer;
